import { TextBlock } from './TextBlock';
import { ErrorBlock } from './ErrorBlock';
import { JobBlock } from './job';
import { JobListBlock } from './jobList';
import { ContactListBlock } from './contactList';
import { CandidateBlock } from './candidate';
import { ClarifyBlock } from './clarify';
import { ClarifyFormBlock } from './clarifyForm';
import { ResumeBlock } from './resume';
import { DataTableBlock } from './dataTable';
import { CandidateProfilesBlock } from './candidateProfiles';
import { EmailComposeBlock } from './emailCompose';
import { ActionResultBlock } from './actionResult';
import { ApprovalBlock } from './approval';
import type { BlockRegistry } from './registry.types';

// Maps a block `type` to its renderer. Each entry expects props of the shape
// `{ data: <variant data> }`. Phase 3 follow-ups append flow / file / entity.
// actionResult doubles as the generic fallback for unknown entities — without
// it those payloads rendered as blank space.
export const BLOCK_REGISTRY: BlockRegistry = {
  text: TextBlock,
  error: ErrorBlock,
  job: JobBlock,
  jobList: JobListBlock,
  contactList: ContactListBlock,
  candidate: CandidateBlock,
  clarify: ClarifyBlock,
  clarifyForm: ClarifyFormBlock,
  resume: ResumeBlock,
  dataTable: DataTableBlock,
  candidateProfiles: CandidateProfilesBlock,
  emailCompose: EmailComposeBlock,
  actionResult: ActionResultBlock,
  approval: ApprovalBlock,
};
